<template>
  <div class="trigger_tip">
    <div class="tip_content">
      <template v-for="(value, index) in activeDatas" :key="index">
        <span class="trigger_tip_text">{{ kbVKTexture[value] || t(mouseVKs[value]) }}</span>
        <span v-if="index < activeDatas.length - 1" class="assist_add">+</span>
      </template>
    </div>
    <div class="tip_arrow"></div>
  </div>
</template>

<script lang="ts" setup>
import { VK } from '@/define/define'
import { kbVKTexture, mouseVKs } from '@/define/vkcode'
import { computed } from 'vue'
import i18n from '@/languages/i18n'
const { t } = i18n.global

const props = defineProps<{ datas: VK[] }>()
const activeDatas = computed(() => (props.datas || []).filter((e) => e > 0))
</script>

<style lang="less" scoped>
.trigger_tip {
  position: absolute;
  bottom: calc(100% + 12px);
  left: 50%;
  transform: translateX(-50%) translateY(10px);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1000;
  pointer-events: none;
  opacity: 0;
  transition: var(--transition-base);
  width: max-content; /* 锁定内容的原始宽度，防止被父容器压缩 */

  .tip_content {
    background: var(--glass-surface-bg);
    backdrop-filter: var(--glass-surface-blur);
    padding: 10px 14px;
    border-radius: var(--radius-l);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;

    .assist_add {
      color: var(--color-text-hint);
      font-weight: 500;
      font-size: 14px;
      opacity: 0.6;
    }

    .trigger_tip_text {
      color: var(--color-dark);
      font-size: 12px;
      font-weight: 700;
      background: var(--color-gray-1);
      padding: 3px 10px;
      border-radius: var(--action-btn-radius);
      border: 1px solid rgba(0, 0, 0, 0.05);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
    }
  }

  .tip_arrow {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid rgba(255, 255, 255, 0.85); /* 稍微降低不透明度匹配内容区 */
    margin-top: -1px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.05));
  }
}
</style>
